import React, { useCallback, useEffect, useState } from 'react';
import { modalSubject } from '../../index';
import { Modal as ModalBase } from '../../../../components/modal';
const Render = ({ Component }, parentModalProps) => <Component {...parentModalProps}/>;
export const Modal = () => {
    const [isOpen, setOpen] = useState(false);
    const [modalBody, setModalBody] = useState({ component: null });
    const [modalProps, setModalProps] = useState(null);
    useEffect(() => {
        const modalSubscription = modalSubject.subscribe(modalComponent => {
            setOpen(Boolean(modalComponent));
            if (modalComponent) {
                setModalBody({
                    component: modalComponent.component
                });
                if (modalComponent.parentModalProps) {
                    setModalProps(modalComponent.parentModalProps);
                }
            }
        });
        return () => {
            modalSubscription.unsubscribe();
        };
    }, []);
    const handleClose = useCallback(() => {
        if (modalProps?.onCloseCallback) {
            modalProps.onCloseCallback();
        }
        modalSubject.next(null);
    }, [modalProps]);
    if (!Boolean(modalBody.component)) {
        return null;
    }
    return (<ModalBase isOpen={isOpen} onClose={handleClose} {...modalProps}>
      {Render({ Component: modalBody.component }, { ...modalProps, handleClose })}
    </ModalBase>);
};
